module.exports = __webpack_public_path__ + "img/1.d14c3003.png";